import React from 'react'
import { connect } from 'react-redux'

import Modal from '../Modal/Modal'
import { setAppVersionStatus } from '../../store/actions/appVersion'

const VersionWarningModal = ({ isOutdated, onCloseModal }) => (
  <Modal open={isOutdated} onCloseModal={onCloseModal}>
    <p className="modal__description">Nova versão do App no ar. Atualize o quanto antes</p>
  </Modal>
)

const mapStateToProps = state => ({
  isOutdated: Boolean(state.appVersion?.isOutdated),
})

const mapDispatchToProps = dispatch => ({
  onCloseModal: () => dispatch(setAppVersionStatus(false)),
})

export default connect(mapStateToProps, mapDispatchToProps)(VersionWarningModal)
